// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as ConsultingForm from "./ConsultingForm.bs.js";
import * as ConsultingRates from "./ConsultingRates.bs.js";

function App(Props) {
  var match = React.useState(function () {
        return {
                value: 0,
                currency: /* USD */0,
                duration: /* Hourly */0
              };
      });
  var setRate = match[1];
  var onSubmit = function (values) {
    return Curry._1(setRate, (function (_prev) {
                  return values;
                }));
  };
  return React.createElement("div", {
              className: "bg-blue-50 w-full flex justify-center items-center py-8 h-screen"
            }, React.createElement("div", {
                  className: "w-11/12 p-12 sm:w-8/12 md:w-6/12 lg:w-1/2  \n        mx-auto py-10 bg-white flex-col justify-center items-center rounded-3xl shadow hover:shadow-md duration-4 min-h-1/2"
                }, React.createElement("header", {
                      className: "flex flex-column justify-center self-center h-24"
                    }, React.createElement("h2", {
                          className: "p-2.5 text-blue-500 text-3xl"
                        }, "Rate Calculator")), React.createElement("div", {
                      className: "md:grid md:grid-cols-2 md:gap-12"
                    }, React.createElement(ConsultingForm.make, {
                          onSubmit: onSubmit
                        }), React.createElement(ConsultingRates.make, {
                          rate: match[0]
                        }))));
}

var make = App;

export {
  make ,
  
}
/* react Not a pure module */
